import { SocialButton, Stack } from '@drycut/ui-components';

type Props = {
  code: string;
};

export default function SocialLinks({ code }: Props): React.ReactElement {
  const emailSubject = 'Dein 13 CHF Gutschein bei DRYCUT';
  const url = `https://rf.drycut.ch/referral/${code}`;
  const shareText = `Dein persönlicher 13 CHF Gutschein bei DRYCUT – weitere Infos dazu findest du hier: ${url}`;

  const href = {
    whatsapp: `https://api.whatsapp.com/send?phone=&text=${encodeURIComponent(shareText)}`,
    facebook: `https://www.facebook.com/share.php?u=${encodeURIComponent(url)}`,
    email: `mailto:?subject=${emailSubject}&body=${shareText}`,
  };

  return (
    <Stack direction="row" gap={3}>
      <SocialButton social="whatsapp" href={href.whatsapp} />

      <SocialButton social="facebook" href={href.facebook} />

      <SocialButton social="email" href={href.email} />
    </Stack>
  );
}
